import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightDossier'
})
export class HighlightDossierPipe implements PipeTransform {
  transform(value: any, search: string): string {
    // Ensure value is a string
    const stringValue = typeof value === 'string' ? value : String(value ?? "");
    
    if (!search || search.length === 0 || !stringValue) {
      return stringValue;
    }

    const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const searchWords = escapedSearch.split(' ').filter(word => word.length > 0);
    if (searchWords.length === 0) {
      return stringValue;
    }

    const re = new RegExp(searchWords.join('|'), 'gi');
    return stringValue.replace(re, (match) => `<b>${match}</b>`);
  }
}
